var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"slider-bg",style:({
        'background-image':
          'url(' + require('../../assets/image/faq.jpg') + ')'
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }